const CURRENCY_PREFIX = {
  ZAR: 'R',
  USD: '$',
  EUR: '€',
  GBP: '£',
};

export const formatMoney = (minorUnits, currency = 'ZAR') => {
  const value = (Number(minorUnits) || 0) / 100;
  const parts = value.toFixed(2).split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  const prefix = CURRENCY_PREFIX[currency] ?? `${currency}`;
  return `${prefix}${parts.join('.')}`;
};

export const formatBalls = (balls) => {
  if (!balls || balls.length === 0) return '';
  return balls.map((b) => b.value).join(', ');
};

export const isWon = (status) =>
  status === 'won' || status === 'partially_won';

export const mapBetStatus = (apiStatus) => {
  switch (apiStatus) {
    case 'accepted':
      return 'Registered';
    case 'scheduled':
      return 'Pending';
    case 'won':
      return 'Won';
    case 'partially_won':
      return 'Won';
    case 'lost':
      return 'Lost';
    case 'cancelled':
      return 'Cancelled';
    default:
      return apiStatus;
  }
};
